export default __webpack_public_path__ + "static/media/banner.8c706df3.webp";